import { Checkbox, Divider, Field, Form, Grid, Input, Select, Switch, Tab, Tree } from "@alifd/next";
import { BefGlobalContext, BefMessageServiceContext, BefRpcContext } from "@beflam/bef-core";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { fetchAIUserList } from "../AiColleague/aiColleagueService";
const CheckboxGroup = Checkbox.Group;
const UserPermission = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, ids, ...otherProps } = props;
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const sGlobal = useContext(BefGlobalContext) as any;
    const [dataSource, setDataSource] = useState({});
    const [tabFlag, setTabFlag] = useState(0);
    let [treeData, setTreeData] = useState({ datas: {} as any, isLoaded: {} as any, checkedKeys: {} as any });
    const setTreeDataEx = (data: any) => {
        treeData = data;
        setTreeData(data);
    }
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    const [roleCheckedList, setRoleCheckedList] = useState<any>([]);
    const [roleIndeterminate, setRoleIndeterminate] = useState(false);
    const [roleCheckAll, setRoleCheckAll] = useState(false);
    const [roleOptions, setRoleOptions] = useState<{ Roles: any, Permissions: any, DataAuthorities: any }>({ Roles: [], Permissions: [], DataAuthorities: [] });
    const [perCheckedList, setPerCheckedList] = useState<any>(null);
    const [perIndeterminate, setPerIndeterminate] = useState(false);
    const [perCheckAll, setPerCheckAll] = useState(false);
    const [perCheckedCount, setPerCheckedCount] = useState(0);
    const [dataCheckedList, setDataCheckedList] = useState<any>(null);
    const [dataIndeterminate, setDataIndeterminate] = useState(false);
    const [dataCheckAll, setDataCheckAll] = useState(false);
    const [dataCheckedCount, setDataCheckedCount] = useState(0);

    // Agent config states
    const [agentConfig, setAgentConfig] = useState<any>({ AIAgent: false, AIColleague: false, AIPermission: false, AIColleagueIds: [] });
    const agentConfigRef = useRef<any>({ AIAgent: false, AIColleague: false, AIPermission: false, AIColleagueIds: [] });
    const [agentConfigOriginal, setAgentConfigOriginal] = useState<any>(null);
    const agentConfigOriginalRef = useRef<any>(null);
    const [agentLoaded, setAgentLoaded] = useState(false);
    const [aiColleagueList, setAiColleagueList] = useState<any[]>([]);
    const [aiColleagueListLoaded, setAiColleagueListLoaded] = useState(false);

    // UA (Agent-specific) Role/Permission states
    const [uaTabFlag, setUaTabFlag] = useState(0);
    const [uaRoleCheckedList, setUaRoleCheckedList] = useState<any>([]);
    const [uaRoleIndeterminate, setUaRoleIndeterminate] = useState(false);
    const [uaRoleCheckAll, setUaRoleCheckAll] = useState(false);
    const [uaRoleOptions, setUaRoleOptions] = useState<{ Roles: any, Permissions: any }>({ Roles: [], Permissions: [] });
    const [uaPerCheckedList, setUaPerCheckedList] = useState<any>(null);
    const [uaPerIndeterminate, setUaPerIndeterminate] = useState(false);
    const [uaPerCheckAll, setUaPerCheckAll] = useState(false);
    const [uaPerCheckedCount, setUaPerCheckedCount] = useState(0);
    let [uaTreeData, setUaTreeData] = useState({ isLoaded: {} as any });
    const setUaTreeDataEx = (data: any) => {
        uaTreeData = data;
        setUaTreeData(data);
    }

    const getTreeNodeData = (type: string, idKey: string, data: any, checkedKeys: string[], prefix: string = "") => {
        const { Description, Selected } = data;
        let key = `${prefix}${data[idKey]}`;
        if (Selected == true) checkedKeys.push(key);
        let children = data[`${type}Roles`]?.map((val: any) => getTreeNodeData(type, idKey, val, checkedKeys, `${key}&`));
        return { key: key, label: Description, extraData: data, children: children };
    }

    const loadAgentConfig = async () => {
        if (agentLoaded) return;
        try {
            let result = ids.length === 1 ? await befRpc.callRpcAsync("", "Beflam.Framework", "Beflam.Framework.Service.UserService", "GetExtendData", { userId: ids[0], key: "Agent"}) as any : null;
            let config: any = { AIAgent: false, AIColleague: false, AIPermission: false, AIColleagueIds: [] };
            if (result) {
                try {
                    let parsed = typeof result === 'string' ? JSON.parse(result) : result;
                    config = { ...config, ...parsed };
                } catch (e) { }
            }
            setAgentConfig(config);
            agentConfigRef.current = config;
            setAgentConfigOriginal({ ...config });
            agentConfigOriginalRef.current = { ...config };
            setAgentLoaded(true);
            if (config.AIPermission) {
                onUaTabChange('Role');
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, `用户权限配置：获取Agent配置`));
        }
    }

    const saveAgentConfig = async () => {
        const current = agentConfigRef.current;
        const original = agentConfigOriginalRef.current;
        if (!original) return;
        if (current.AIAgent !== original.AIAgent ||
            current.AIColleague !== original.AIColleague ||
            current.AIPermission !== original.AIPermission ||
            JSON.stringify(current.AIColleagueIds ?? []) !== JSON.stringify(original.AIColleagueIds ?? [])) {
            await befRpc.callRpcAsync("", "Beflam.Framework", "Beflam.Framework.Service.UserService", "SetExtendData", { key: "Agent", users: ids, data: current});
        }
    }

    const loadAIColleagueList = async () => {
        if (aiColleagueListLoaded) return;
        try {
            const list = await fetchAIUserList(sGlobal);
            setAiColleagueList(list);
            setAiColleagueListLoaded(true);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, 'AI同事'));
        }
    };

    const onTabChange = async (key: any) => {
        try {
            if (key == 'Role') setTabFlag(0);
            else if (key == 'Permission') setTabFlag(1);
            else if (key == 'DataAuthority') setTabFlag(2);
            else if (key == 'Agent') {
                setTabFlag(3);
                await loadAgentConfig();
                return;
            }
            if (treeData.isLoaded[key] == true) return;
            let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Permission", { Action: "Get", Type: key, Users: ids }) as any;
            let isLoaded = { ...treeData.isLoaded };
            isLoaded[key] = true;
            let _dataOptions = [] as any;
            let _selected = [] as any;
            if (key == 'Role') {
                if (result && result.length > 0) {
                    _dataOptions = result.map((item: any) => {
                        if (item.Selected)
                            _selected.push(item.Id);
                        return { label: item.Description, value: item.Id };
                    });
                    setRoleOptions({ ...roleOptions, Roles: _dataOptions });

                    if (_selected.length > 0) {
                        if (_selected.length == _dataOptions.length) {
                            setRoleIndeterminate(false);
                            setRoleCheckAll(true);
                        } else {
                            setRoleIndeterminate(true);
                            setRoleCheckAll(false);
                        }

                    } else {
                        setRoleIndeterminate(false);
                        setRoleCheckAll(false);
                    }

                    setRoleCheckedList(_selected);
                }

            }
            else if (key == 'Permission') {
                if (result.Permissions && result.Permissions.length > 0) {
                    let _total = 0;
                    let _snum = 0;
                    _dataOptions = result.Permissions.map((item: any) => {

                        let _pers = [];
                        let _perselected = [] as any;
                        if (item.PermissionRoles && item.PermissionRoles.length > 0) {
                            _pers = item.PermissionRoles.map((it: any) => {
                                if (it.Selected) {
                                    _perselected.push(it.ID);
                                    _snum++;
                                }
                                _total++;
                                return { label: it.Description, value: it.ID };
                            })
                        }
                        _selected[item.ID] = _perselected;
                        return { Description: item.Description, Id: item.ID, PermissionRoles: _pers };
                    });
                    setPerCheckedList(_selected);
                    setRoleOptions({ ...roleOptions, Permissions: _dataOptions });
                    setPerCheckedCount(_total);
                    if (_snum == 0) {
                        setPerIndeterminate(false);
                        setPerCheckAll(false);
                    } else {
                        if (_snum == _total) {
                            setPerIndeterminate(false);
                            setPerCheckAll(true)
                        } else {
                            setPerIndeterminate(true);
                            setPerCheckAll(false)
                        }
                    }
                }

            }
            else {
                if (result.DataAuthorities && result.DataAuthorities.length > 0) {
                    let _total = 0;
                    let _snum = 0;
                    _dataOptions = result.DataAuthorities.map((item: any) => {

                        let _pers = [];
                        let _perselected = [] as any;
                        if (item.AuthorityRoles && item.AuthorityRoles.length > 0) {
                            _pers = item.AuthorityRoles.map((it: any) => {
                                if (it.Selected) {
                                    _perselected.push(it.ID);
                                    _snum++;
                                }
                                _total++;
                                return { label: it.Description, value: it.ID };
                            })
                        }
                        _selected[item.ID] = _perselected;
                        return { Description: item.Description, Id: item.ID, AuthorityRoles: _pers };
                    });
                    setDataCheckedList(_selected);
                    setRoleOptions({ ...roleOptions, DataAuthorities: _dataOptions });
                    setDataCheckedCount(_total);
                    if (_snum == 0) {
                        setDataIndeterminate(false);
                        setDataCheckAll(false);
                    } else {
                        if (_snum == _total) {
                            setDataIndeterminate(false);
                            setDataCheckAll(true)
                        } else {
                            setDataIndeterminate(true);
                            setDataCheckAll(false)
                        }
                    }
                }
            }
            setTreeDataEx({ ...treeData, datas: [], isLoaded: isLoaded, checkedKeys: [] });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, `用户权限配置：获取${key}数据`));
        }
    }

    const onUaTabChange = async (key: any) => {
        try {
            if (key == 'Role') setUaTabFlag(0);
            else setUaTabFlag(1);
            if (uaTreeData.isLoaded[key] == true) return;
            let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Permission", { Action: "Get", Type: key, Users: ids, UserType: "UA" }) as any;
            let isLoaded = { ...uaTreeData.isLoaded };
            isLoaded[key] = true;
            let _dataOptions = [] as any;
            let _selected = [] as any;
            if (key == 'Role') {
                if (result && result.length > 0) {
                    _dataOptions = result.map((item: any) => {
                        if (item.Selected)
                            _selected.push(item.Id);
                        return { label: item.Description, value: item.Id };
                    });
                    setUaRoleOptions({ ...uaRoleOptions, Roles: _dataOptions });
                    if (_selected.length > 0) {
                        if (_selected.length == _dataOptions.length) {
                            setUaRoleIndeterminate(false);
                            setUaRoleCheckAll(true);
                        } else {
                            setUaRoleIndeterminate(true);
                            setUaRoleCheckAll(false);
                        }
                    } else {
                        setUaRoleIndeterminate(false);
                        setUaRoleCheckAll(false);
                    }
                    setUaRoleCheckedList(_selected);
                }
            } else if (key == 'Permission') {
                if (result.Permissions && result.Permissions.length > 0) {
                    let _total = 0;
                    let _snum = 0;
                    _dataOptions = result.Permissions.map((item: any) => {
                        let _pers = [];
                        let _perselected = [] as any;
                        if (item.PermissionRoles && item.PermissionRoles.length > 0) {
                            _pers = item.PermissionRoles.map((it: any) => {
                                if (it.Selected) {
                                    _perselected.push(it.ID);
                                    _snum++;
                                }
                                _total++;
                                return { label: it.Description, value: it.ID };
                            })
                        }
                        _selected[item.ID] = _perselected;
                        return { Description: item.Description, Id: item.ID, PermissionRoles: _pers };
                    });
                    setUaPerCheckedList(_selected);
                    setUaRoleOptions({ ...uaRoleOptions, Permissions: _dataOptions });
                    setUaPerCheckedCount(_total);
                    if (_snum == 0) {
                        setUaPerIndeterminate(false);
                        setUaPerCheckAll(false);
                    } else {
                        if (_snum == _total) {
                            setUaPerIndeterminate(false);
                            setUaPerCheckAll(true)
                        } else {
                            setUaPerIndeterminate(true);
                            setUaPerCheckAll(false)
                        }
                    }
                }
            }
            setUaTreeDataEx({ ...uaTreeData, isLoaded: isLoaded });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, `用户权限配置：获取Agent ${key}数据`));
        }
    }

    const saveData = async () => {
        let mode = fieldRef.current.getValue("mode");
        let _per = [] as any;
        if (perCheckedList) {
            for (let i in perCheckedList) {
                if (perCheckedList[i].length > 0) {
                    _per.push({ Id: i, Roles: perCheckedList[i] })
                }
            }
        } else
            _per = null;
        let _data = [] as any;
        if (dataCheckedList) {
            for (let i in dataCheckedList) {
                if (dataCheckedList[i].length > 0) {
                    _data.push({ Id: i, Roles: dataCheckedList[i] })
                }
            }
        } else
            _data = null;
        let data = {
            Role: roleCheckedList ?? null,
            Permission: _per ?? null,
            DataAuthority: _data ?? null
        };

        let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Permission", { Action: "Save", Users: ids, Mode: mode, Datas: data });

        // Save agent config if switches changed
        await saveAgentConfig();

        // Save UA role/permission if AIPermission is on
        if (agentConfig.AIPermission) {
            let _uaPer = [] as any;
            if (uaPerCheckedList) {
                for (let i in uaPerCheckedList) {
                    if (uaPerCheckedList[i].length > 0) {
                        _uaPer.push({ Id: i, Roles: uaPerCheckedList[i] })
                    }
                }
            } else
                _uaPer = null;
            let uaData = {
                Role: uaRoleCheckedList ?? null,
                Permission: _uaPer ?? null,
            };
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Permission", { Action: "Save", Users: ids, Mode: mode, Datas: uaData, UserType: "UA" });
        }

        return result;
    }
    const onRoleChange = (list: string | any[]) => {
        setRoleCheckedList(list);
        setRoleIndeterminate(!!list.length && list.length < roleOptions.Roles.length);
        setRoleCheckAll(list.length === roleOptions.Roles.length);
    };
    const onRoleCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        if (e.target.checked) {
            let _selected = [];
            if (roleOptions && roleOptions.Roles.length > 0) {
                _selected = roleOptions.Roles.map(((item: any) => {
                    return item.value;
                }));
            }
            setRoleCheckedList(_selected);
        } else {
            setRoleCheckedList([]);
        }

        setRoleIndeterminate(false);
        setRoleCheckAll(e.target.checked);
    };
    const onPerChange = (list: string | any[], id: any) => {
        let _data = { ...perCheckedList };
        _data[id] = list;
        setPerCheckedList(_data);
        let _selected = 0;
        for (let i in _data) {
            _selected += _data[i].length;
        }
        if (_selected == 0) {
            setPerIndeterminate(false);
            setPerCheckAll(false);
        } else {
            if (_selected == perCheckedCount) {
                setPerIndeterminate(false);
                setPerCheckAll(true);
            } else {
                setPerIndeterminate(true);
                setPerCheckAll(false);
            }

        }
    };
    const onPerCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        let _selected = [] as any;
        if (roleOptions && roleOptions.Permissions.length > 0) {
            roleOptions.Permissions.map(((item: any) => {
                let _se = [] as any;
                if (item.PermissionRoles && item.PermissionRoles.length > 0) {
                    item.PermissionRoles.map((it: any) => {
                        _se.push(it.value);
                    });
                }
                if (e.target.checked)
                    _selected[item.Id] = _se;
                else _selected[item.Id] = [];
            }));
        }
        setPerCheckedList(_selected);
        setPerIndeterminate(false);
        setPerCheckAll(e.target.checked);
    };
    const onDataChange = (list: string | any[], id: any) => {
        let _data = { ...dataCheckedList };
        _data[id] = list;
        setDataCheckedList(_data);
        let _selected = 0;
        for (let i in _data) {
            _selected += _data[i].length;
        }
        if (_selected == 0) {
            setDataIndeterminate(false);
            setDataCheckAll(false);
        } else {
            if (_selected == dataCheckedCount) {
                setDataIndeterminate(false);
                setDataCheckAll(true);
            } else {
                setDataIndeterminate(true);
                setDataCheckAll(false);
            }

        }
    };
    const onDataCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        let _selected = [] as any;
        if (roleOptions && roleOptions.DataAuthorities.length > 0) {
            roleOptions.DataAuthorities.map(((item: any) => {
                let _se = [] as any;
                if (item.AuthorityRoles && item.AuthorityRoles.length > 0) {
                    item.AuthorityRoles.map((it: any) => {
                        _se.push(it.value);
                    });
                }
                if (e.target.checked)
                    _selected[item.Id] = _se;
                else _selected[item.Id] = [];
            }));
        }
        setDataCheckedList(_selected);
        setDataIndeterminate(false);
        setDataCheckAll(e.target.checked);
    };

    // UA Role/Permission change handlers
    const onUaRoleChange = (list: string | any[]) => {
        setUaRoleCheckedList(list);
        setUaRoleIndeterminate(!!list.length && list.length < uaRoleOptions.Roles.length);
        setUaRoleCheckAll(list.length === uaRoleOptions.Roles.length);
    };
    const onUaRoleCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        if (e.target.checked) {
            let _selected = [];
            if (uaRoleOptions && uaRoleOptions.Roles.length > 0) {
                _selected = uaRoleOptions.Roles.map(((item: any) => {
                    return item.value;
                }));
            }
            setUaRoleCheckedList(_selected);
        } else {
            setUaRoleCheckedList([]);
        }
        setUaRoleIndeterminate(false);
        setUaRoleCheckAll(e.target.checked);
    };
    const onUaPerChange = (list: string | any[], id: any) => {
        let _data = { ...uaPerCheckedList };
        _data[id] = list;
        setUaPerCheckedList(_data);
        let _selected = 0;
        for (let i in _data) {
            _selected += _data[i].length;
        }
        if (_selected == 0) {
            setUaPerIndeterminate(false);
            setUaPerCheckAll(false);
        } else {
            if (_selected == uaPerCheckedCount) {
                setUaPerIndeterminate(false);
                setUaPerCheckAll(true);
            } else {
                setUaPerIndeterminate(true);
                setUaPerCheckAll(false);
            }
        }
    };
    const onUaPerCheckAllChange = (checked: any, e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        let _selected = [] as any;
        if (uaRoleOptions && uaRoleOptions.Permissions.length > 0) {
            uaRoleOptions.Permissions.map(((item: any) => {
                let _se = [] as any;
                if (item.PermissionRoles && item.PermissionRoles.length > 0) {
                    item.PermissionRoles.map((it: any) => {
                        _se.push(it.value);
                    });
                }
                if (e.target.checked)
                    _selected[item.Id] = _se;
                else _selected[item.Id] = [];
            }));
        }
        setUaPerCheckedList(_selected);
        setUaPerIndeterminate(false);
        setUaPerCheckAll(e.target.checked);
    };

    const extraContent = (
        <>  {
            tabFlag == 0 && <div className="display-flex justify-end">
                <Checkbox className="custom-form-control" indeterminate={roleIndeterminate} onChange={onRoleCheckAllChange} checked={roleCheckAll}>
                    Check all
                </Checkbox>
            </div>
        }
            {
                tabFlag == 1 && <div className="display-flex justify-end">
                    <Checkbox className="custom-form-control" indeterminate={perIndeterminate} onChange={onPerCheckAllChange} checked={perCheckAll}>
                        Check all
                    </Checkbox></div>
            }
            {
                tabFlag == 2 && <div className="display-flex justify-end">
                    <Checkbox className="custom-form-control" indeterminate={dataIndeterminate} onChange={onDataCheckAllChange} checked={dataCheckAll}>
                        Check all
                    </Checkbox></div>
            }
        </>

    )

    const uaExtraContent = (
        <>
            {uaTabFlag == 0 && <div className="display-flex justify-end">
                <Checkbox className="custom-form-control" indeterminate={uaRoleIndeterminate} onChange={onUaRoleCheckAllChange} checked={uaRoleCheckAll}>
                    Check all
                </Checkbox>
            </div>}
            {uaTabFlag == 1 && <div className="display-flex justify-end">
                <Checkbox className="custom-form-control" indeterminate={uaPerIndeterminate} onChange={onUaPerCheckAllChange} checked={uaPerCheckAll}>
                    Check all
                </Checkbox>
            </div>}
        </>
    )

    useEffect(() => {
        fieldRef.current.reset();
        fieldRef.current.setValues({ ids: "", mode: "" });
    }, []);
    useEffect(() => {
        fieldRef.current.setValue("ids", ids ? ids.join(",") : "");
        onTabChange("Role");
        setTabFlag(0);
        // Reset agent state
        setAgentLoaded(false);
        setAgentConfig({ AIAgent: false, AIColleague: false, AIPermission: false, AIColleagueIds: [] });
        agentConfigRef.current = { AIAgent: false, AIColleague: false, AIPermission: false, AIColleagueIds: [] };
        setAgentConfigOriginal(null);
        agentConfigOriginalRef.current = null;
        setAiColleagueListLoaded(false);
        setAiColleagueList([]);
        setUaTreeDataEx({ isLoaded: {} });
        setUaRoleCheckedList([]);
        setUaRoleOptions({ Roles: [], Permissions: [] });
        setUaPerCheckedList(null);
    }, [ids]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        proxy.save = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate(async (errors: any, values: any) => {
                        try {
                            if (errors != null) return;
                            let result = await saveData();
                            resolve(result);
                        } catch (error) {
                            reject(error);
                        }
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, [rpcAssembly, rpcModule, treeData, roleCheckedList, perCheckedList, dataCheckedList, agentConfig, agentConfigOriginal, uaRoleCheckedList, uaPerCheckedList]);
    return (
        <Form style={{ minHeight: "400px" }} field={fieldRef.current} className="bef-custom-user">
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item required label="Selected User" name="ids" className="custom-form-control">
                        <Input disabled />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    {ids && ids.length > 1 &&
                        <Form.Item required label="Assign Mode" name="mode" className="custom-form-control">
                            <Select style={{ width: '100%' }} >
                                <Select.Option value="Add">Add</Select.Option>
                                <Select.Option value="Delete">Delete</Select.Option>
                                <Select.Option value="Override">Override</Select.Option>
                            </Select>
                        </Form.Item>}
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <div className="tab-div dialog-tab">
                        <Tab lazyLoad={false} onChange={onTabChange} extra={extraContent}>
                            <Tab.Item title="Role" key="Role">
                                {/* <Tree style={{ marginTop: "16px" }} checkable isNodeBlock
                                    checkedKeys={treeData.checkedKeys.Role} dataSource={treeData.datas.Role}
                                    onCheck={(checkedKeys: any[], extra: any) => onTabCheck(checkedKeys, extra, "Role")} /> */}
                                <div className="bef-user-check-group">
                                    <div className="check-con sp">
                                        <Checkbox.Group className="custom-form-control flex-1" value={roleCheckedList} onChange={onRoleChange} >
                                            {roleOptions.Roles.map((item: any) => {
                                                return <>
                                                    <div style={{ padding: '8px', display: 'flex' }}>
                                                        <span className="per-desc"> {item.value}
                                                            <span style={{ marginLeft: '16px' }}>{item.label} </span></span>
                                                        <Checkbox value={item.value}> </Checkbox>
                                                    </div>
                                                </>
                                            })}
                                        </Checkbox.Group>
                                    </div>
                                </div>
                            </Tab.Item>
                            <Tab.Item title="Permission" key="Permission">
                                {/* <Tree style={{ marginTop: "16px" }} checkable isNodeBlock
                                    checkedKeys={treeData.checkedKeys.Permission} dataSource={treeData.datas.Permission}
                                    onCheck={(checkedKeys: any[], extra: any) => onTabCheck(checkedKeys, extra, "Permission")} /> */}
                                <div className="bef-user-check-group">
                                    <div className="check-con">
                                        <ul>
                                            {roleOptions.Permissions.map((pers: any) => <>
                                                <li> <span className="per-desc"> {pers.Description}</span>
                                                    <CheckboxGroup className="flex-1 custom-form-control" dataSource={pers.PermissionRoles} value={perCheckedList[pers.Id]}
                                                        onChange={(val) => { onPerChange(val, pers.Id) }} />
                                                </li>
                                            </>)
                                            }
                                        </ul>
                                    </div>

                                </div>

                            </Tab.Item>
                            <Tab.Item title="DataAuthority" key="DataAuthority">
                                <div className="bef-user-check-group">
                                    <div className="check-con">
                                        <ul>
                                            {roleOptions.DataAuthorities.map((pers: any) => <>
                                                <li> <span className="per-desc"> {pers.Description}</span>
                                                    <CheckboxGroup className="flex-1 custom-form-control" dataSource={pers.AuthorityRoles} value={dataCheckedList[pers.Id]}
                                                        onChange={(val) => { onDataChange(val, pers.Id) }} />
                                                </li>
                                            </>)
                                            }</ul></div></div>
                            </Tab.Item>
                            <Tab.Item title="Agent" key="Agent">
                                <div style={{ padding: '16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '16px' }}>
                                        <span>AI助理 <Switch checked={agentConfig.AIAgent} onChange={(val: boolean) => { const c = { ...agentConfig, AIAgent: val }; setAgentConfig(c); agentConfigRef.current = c; }} /></span>
                                        <span>AI同事 <Switch checked={agentConfig.AIColleague} onChange={(val: boolean) => {
                                            const c = { ...agentConfig, AIColleague: val };
                                            setAgentConfig(c);
                                            agentConfigRef.current = c;
                                            if (val) loadAIColleagueList();
                                        }} /></span>
                                        <span>Agent单独权限 <Switch checked={agentConfig.AIPermission} onChange={(val: boolean) => {
                                            const c = { ...agentConfig, AIPermission: val };
                                            setAgentConfig(c);
                                            agentConfigRef.current = c;
                                            if (val && !uaTreeData.isLoaded['Role']) {
                                                onUaTabChange('Role');
                                            }
                                        }} /></span>
                                    </div>
                                    {agentConfig.AIColleague && (
                                        <div style={{ marginBottom: '16px' }}>
                                            <span style={{ marginRight: '8px' }}>AI同事选择：</span>
                                            <Select
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                dataSource={aiColleagueList.map((item: any) => ({ value: item.Id, label: item.Name }))}
                                                value={agentConfig.AIColleagueIds || []}
                                                onChange={(val: any) => {
                                                    const c = { ...agentConfig, AIColleagueIds: val };
                                                    setAgentConfig(c);
                                                    agentConfigRef.current = c;
                                                }}
                                                onVisibleChange={(vis: boolean) => { if (vis) loadAIColleagueList(); }}
                                            />
                                        </div>
                                    )}
                                    {agentConfig.AIPermission && (
                                        <div className="tab-div dialog-tab">
                                            <Tab lazyLoad={false} onChange={onUaTabChange} defaultActiveKey="Role" extra={uaExtraContent}>
                                                <Tab.Item title="Role" key="Role">
                                                    <div className="bef-user-check-group">
                                                        <div className="check-con sp">
                                                            <Checkbox.Group className="custom-form-control flex-1" value={uaRoleCheckedList} onChange={onUaRoleChange} >
                                                                {uaRoleOptions.Roles.map((item: any) => {
                                                                    return <>
                                                                        <div style={{ padding: '8px', display: 'flex' }}>
                                                                            <span className="per-desc"> {item.value}
                                                                                <span style={{ marginLeft: '16px' }}>{item.label} </span></span>
                                                                            <Checkbox value={item.value}> </Checkbox>
                                                                        </div>
                                                                    </>
                                                                })}
                                                            </Checkbox.Group>
                                                        </div>
                                                    </div>
                                                </Tab.Item>
                                                <Tab.Item title="Permission" key="Permission">
                                                    <div className="bef-user-check-group">
                                                        <div className="check-con">
                                                            <ul>
                                                                {uaRoleOptions.Permissions.map((pers: any) => <>
                                                                    <li> <span className="per-desc"> {pers.Description}</span>
                                                                        <CheckboxGroup className="flex-1 custom-form-control" dataSource={pers.PermissionRoles} value={uaPerCheckedList[pers.Id]}
                                                                            onChange={(val) => { onUaPerChange(val, pers.Id) }} />
                                                                    </li>
                                                                </>)
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </Tab.Item>
                                            </Tab>
                                        </div>
                                    )}
                                </div>
                            </Tab.Item>
                        </Tab>
                    </div>

                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});

export default UserPermission;
